import { gql } from '@apollo/client'

export const GET_SETTINGS = gql`
  query GetSettings {
    settings {
      plan_settings_id
      plan_type
      setting_key
      setting_value
      parent
    }
  }
`

export const GET_USER_SETTINGS = gql`
  query GetUserSettings {
    userSettings {
      setting_key
      setting_value
    }
  }
`
